import React from "react";
import sos from "./Icons/sos.png";

export const SosInfo = props => {
  return (
    <div className="convenience-item d-flex align-items-center">
      <div className="convenience-symbol__container d-flex align-items-center">
        <img className="convenience-symbol" src={sos} alt="sos" />
      </div>
      <div className="convenience-symbol__description">SOS</div>
    </div>
  );
};
